import { Eye } from "lucide-react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { mockClients } from "../mockData";
import type { TaxRequestJob } from "../types";

const statusConfig: Record<string, { label: string; className: string }> = {
  processing: {
    label: "Processing",
    className: "bg-blue-100 text-blue-700 border-blue-200",
  },
  completed: {
    label: "Completed",
    className: "bg-green-100 text-green-700 border-green-200",
  },
  completed_with_issues: {
    label: "Issues Found",
    className: "bg-amber-100 text-amber-700 border-amber-200",
  },
};

interface TaxRequestListProps {
  jobs: TaxRequestJob[];
  onViewJob: (id: string) => void;
}

export function TaxRequestList({ jobs, onViewJob }: TaxRequestListProps) {
  return (
    <div className="border rounded-lg">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Request Date</TableHead>
            <TableHead>Client</TableHead>
            <TableHead>Filename</TableHead>
            <TableHead>Status</TableHead>
            <TableHead>Found</TableHead>
            <TableHead className="w-[80px]">Actions</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {jobs.length === 0 ? (
            <TableRow>
              <TableCell colSpan={6} className="text-center text-neutral-500 py-8">
                No tax requests yet
              </TableCell>
            </TableRow>
          ) : (
            jobs.map((job) => {
              const client = mockClients.find((c) => c.id === job.clientId);
              const status = statusConfig[job.status];
              return (
                <TableRow key={job.id} className="hover:bg-neutral-50">
                  <TableCell className="text-sm">{job.requestDate}</TableCell>
                  <TableCell className="text-sm">{client?.name || "-"}</TableCell>
                  <TableCell className="text-sm font-medium">{job.requestFilename}</TableCell>
                  <TableCell>
                    <Badge variant="outline" className={`text-xs ${status.className}`}>
                      {status.label}
                    </Badge>
                  </TableCell>
                  <TableCell className="text-sm">
                    <span className="font-medium">{job.totalFound}</span>
                    <span className="text-neutral-400"> / {job.totalRequested}</span>
                  </TableCell>
                  <TableCell>
                    <Button
                      variant="ghost"
                      size="sm"
                      className="h-7 w-7 p-0"
                      onClick={() => onViewJob(job.id)}
                      title="View details"
                    >
                      <Eye className="w-4 h-4" />
                    </Button>
                  </TableCell>
                </TableRow>
              );
            })
          )}
        </TableBody>
      </Table>
    </div>
  );
}
